function checkout(state = {
  checkout: [],
  asiapay: [],
  payment: [],
  adyen: [],
  fetched_adyen: false,
  fetched_payment:false,
  fetched_asiapay:false,
  fetched_computed:false,
  fetching_computed:false,
  fetching: false,
  fetched: false,
  error: null,
  checkoutDetails: {},
  sc_protect_updating: false,
  isOffsizeCheckout: false,
}, action){
  switch (action.type) {
      case 'CHECKOUT_ITEM_REQUEST':{
        return{
          ...state,
          fetchItemComputation: true,
        }
      }
      case 'CHECKOUT_ITEM_FULFILLED':{
        return{
          ...state,
          fetched:true,
          unmounted: true,
          checkout: action.payload,
          error:null,
          fetchItemComputation: false
        }
      }
      case 'CHECKOUT_ITEM_REJECTED':{
        return {
          ...state,
          fetched:false, 
          unmounted:false,       
          error: action.payload,
          fetchItemComputation: false
        }
      }
      case 'CLEAR_CHECKOUT_FULFILLED':{
        return{
          ...state,
          fetched:false,
          fetched_computed:false,
          checkout: [],
        }
      }
      case 'CHECKOUT_ASIAPAY_FULFILLED':{
        return{
          ...state,
          fetched_asiapay:true,
          asiapay: action.payload,
        }
      }
      case 'CHECKOUT_ADYEN_FULFILLED':{
        return{
          ...state,
          fetched_adyen:true,
          adyen: action.payload,
        }
      }
      case 'PROMO_COMPUTED_FULFILLED':{
        return{
          ...state,
          fetched_computed:true,
          fetching_computed: action.payload.data.summary.usd.total_discount > 0 ? true : false,
          checkout: action.payload,
          error: null,
        }
      }
      case 'PROMO_COMPUTED_REJECTED':{
        return{
          ...state,
          fetched_computed:false,
          fetching_computed: false,
          error: action.payload,
        }
      }
      case 'PROMO_COMPUTED_PENDING':{
        return{
          ...state,
          fetching_computed:true,
          
        }
      }
      case 'PAYMENT_FULFILLED':{
        return{
          ...state,
          fetched_payment:true,
          payment: action.payload,
        }
      }
      case 'PAYMENT_REJECTED':{
        return{
          ...state,
          fetched_payment:false,
          error: action.payload,
        }
      }
      case 'RESET_COMPUTED':{
        return{
          ...state,
          fetched_computed:false,
          fetching_computed:false,
        }
      }

      case 'CLEAR_PROMO_ERROR': {
        return {
          ...state,
          error: null
        }
      }

      case 'CHECKOUT_DETAILS':{
        return{
          ...state,
          checkoutDetails: action.payload
        }
      }
      case 'SC_PROTECT_UPDATING':{
        return{
          ...state,
          sc_protect_updating: true,
        }
      }
      case 'SC_PROTECT_UPDATED':{
        return{
          ...state,
          sc_protect_updating: false,
        }
      }
      case 'CHECKOUT_OFFSIZE_ITEM':{
        return{
          ...state,
          isOffsizeCheckout: true,
        }
      }
      case 'CHECKOUT_OFFSIZE_ITEM_RESET':{
        return{
          ...state,
          isOffsizeCheckout: false,
        }
      }
        default: break
   }
   return state;
}
export default checkout;



/** WEBPACK FOOTER **
 ** ./src/reducers/checkout.js
 **/